export default __webpack_public_path__ + "static/media/arrow-right.5ced7773.svg";